import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { HexLogo } from "@/components/dashboard/Hex";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post(
          "/auth/session",
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser({ ...res.data, subscription: null });
        await refresh();
        toast.success(`Welcome, ${res.data.name || res.data.email}`);
        // Clean the URL fragment
        window.history.replaceState({}, document.title, "/pricing");
        navigate("/pricing", { replace: true });
      } catch (err) {
        console.error(err);
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-honeycomb">
      <div className="text-center">
        <HexLogo size={72} className="mx-auto animate-hex-pulse" />
        <p className="mt-6 font-display text-lg font-semibold">Signing you in…</p>
        <p className="text-sm text-zinc-500 mt-1 font-mono-data">
          Exchanging Google session
        </p>
      </div>
    </div>
  );
}
